import {
    createReqConsts,
    createActions,
    createReqReducer,
    createReqWatcher,
  } from '../../utils/redux';
  
  export const consts = createReqConsts('profile', 'disable-mfa');
  export const actions = createActions(consts);
  export const watcher = createReqWatcher(consts, actions, {
    endpoint: 'mfa_settings',
    type: 'delete',
    slug: [
      {
        type: 'payload',
        selector: ['id'],
      },
    ],
  });
  
  export default createReqReducer(consts);
  


// WEBPACK FOOTER //
// ./src/redux/profiles/mfa-disable.js